import { ApolloLink, InMemoryCache } from "@apollo/client/core";
import { provideNamedApollo } from "apollo-angular";
import { HttpLink } from "apollo-angular/http";

import { inject } from "@angular/core";

import generatedIntrospectionIngestor from "../apis/networkdashboard/graphql/types/graphql";
import { createFetchPolicies } from "../apis/networkdashboard/static/client";
import { apiUrl } from "./app.runtime";

const URI_NWD_INGESTOR_DATA = apiUrl("endpoint/private/graphql");

export const namedApolloProvider = provideNamedApollo(() => {
  const httpLink = inject(HttpLink);

  return {
    default: {
      link: ApolloLink.from([httpLink.create({ uri: URI_NWD_INGESTOR_DATA })]),
      cache: new InMemoryCache({
        possibleTypes: generatedIntrospectionIngestor.possibleTypes,
        typePolicies: createFetchPolicies(generatedIntrospectionIngestor),
      }),
    },
  };
});
